
<br> <br> <br> <br>
<div class="row w-100 mx-0 justify-content-center mt-5">
  <div class="col-12 col-md-7 col-lg-8 my-auto  px-md-5 order-md-1 order-2">
    <div class="title">
      {{ "linkedin_optimization" | translate }}
    </div>
    <div class="description">
      {{ "Up Career evaluates your LinkedIn" | translate }}
    </div>
    <button class="gradient-button" (click)="scrollToSteps()">
      {{ "Create LinkedIn Profile" | translate }}
    </button>
  </div>
  <img class="col-8 col-md-5 col-lg-4 text-center p-0 order-md-2 order-1"
    src="../../../assets/img/optimize-linkedIn.png" />
</div>
<div class="mt-5">
  <app-video-tutorial 
    [title]="'generateLinkedinVideo.videoTitle'"
    [buttonText]="'generateLinkedinVideo.videoButton'"
    (buttonClicked)="scrollToSteps()"
    [videoPath]="'../../../assets/video/Recording 2025-11-25 203710.mp4'"
    [videoPoster]="'../../../assets/img/Frame 2095587743.png'"
    [features]="[
      'generateLinkedinVideo.feature1',
      'generateLinkedinVideo.feature2',
      'generateLinkedinVideo.feature3'
    ]">
  </app-video-tutorial>
</div>
<div class="scan mt-4" #stepsSection>{{ "Create LinkedIn Profile" | translate }}</div>
<div class="my-4">
  <p-steps [model]="steps" [(activeIndex)]="activeIndex" />
</div>

<!-- Step 0: Upload LinkedIn PDF + CV -->
<div class="row w-100 m-0" *ngIf="activeIndex === 0" (dragover)="onDragOver($event)" (drop)="onLinkedinDrop($event)">
  <div class="col-lg-8 col-sm-7 col-12 p-0">
    <div class="upload-resume">

      <!-- LinkedIn Upload -->
      <img width="15%" src="../../../assets/img/upload linkedin.png" />
      <h3>{{ "Upload your Public LinkedIn Profile in PDF" | translate }}</h3>
      <p>{{ "Drag and drop your resume as PDF or word file" | translate }}</p>
      <p>{{ "Or" | translate }}</p>
      <input type="file" id="uploadLinkedin" (change)="onLinkedinSelected($event)" accept=".pdf,.doc,.docx"
        #uploadLLinked hidden />
      <button class="button" (click)="uploadLLinked.click()">
        {{ "Select from Browser" | translate }}
      </button>
      <p *ngIf="linkedinFile" class="file-selected-label">
        <i class="pi pi-check-circle"></i> {{ linkedinFile.name }}
      </p>

      <!-- Divider -->
      <div class="cv-upload-divider">
        <span>{{ "Also attach your CV" | translate }}</span>
      </div>

      <!-- CV Upload -->
      <img width="10%" src="../../../assets/icon/pdf.png" />
      <h3>{{ "Upload your CV" | translate }}</h3>
      <p>{{ "Attach your CV to enhance your LinkedIn profile further" | translate }}</p>
      <input type="file" id="uploadCv" (change)="onCvSelected($event)" accept=".pdf,.doc,.docx"
        #uploadCvRef hidden />
      <button class="button" (click)="uploadCvRef.click()">
        {{ "Select CV File" | translate }}
      </button>
      <p *ngIf="cvFile" class="file-selected-label">
        <i class="pi pi-check-circle"></i> {{ cvFile.name }}
      </p>

      <!-- Generate Button — only shown when LinkedIn file is selected -->
      <div class="mt-4" *ngIf="linkedinFile">
        <button class="gradient-button" (click)="onGenerate()">
          {{ "Generate LinkedIn Profile" | translate }}
        </button>
      </div>

    </div>
  </div>
  <div class="col-lg-4 col-sm-5 col-12 p-5 p-sm-3 steps">
    <p>1. {{ "Go to your public LinkedIn profile" | translate }}</p>
    <p>
      2.
      {{ "linkedin_save_to_pdf_hint" | translate }}
    </p>
    <p>
      3.
      {{ "Upload it below and our AI will analyze it instantly." | translate }}
    </p>
    <img width="90%" src="../../../assets/img/upload linkedin steps.png" />
  </div>
</div>

<!-- Step 1: Result / Review -->
<div *ngIf="activeIndex === 1">
  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <div class="loading-spinner">
      <i class="pi pi-spin pi-spinner" style="font-size: 2.5rem; color: rgba(10, 55, 110, 1);"></i>
    </div>
    <p class="loading-text">{{ "Generating your LinkedIn profile..." | translate }}</p>
  </div>

  <!-- Result State -->
<div class="safe-area" *ngIf="!loading && linkedinUrlImage">
  <div class="d-flex justify-content-center align-items-center mb-4">
    <h3 class="title">{{ "Your LinkedIn Profile is Ready!" | translate }}</h3>
  </div>

  <div class="row mx-2 mx-lg-5">
    <div class="col-12 col-md-5 col-lg-4 order-2 order-md-1">

      <div *ngIf="!isWordPurchased">
        <div class="row word" (click)="goToPayment('enhance-linkedin')">
          <p class="col m-0 d-flex align-items-center justify-content-center">
            <img src="./assets/icon/pdf.png" />
            <span>{{ "Purchase LinkedIn Profile" | translate }}</span>
          </p>
          <p class="price col-auto">150 LE</p>
        </div>
      </div>

      <div *ngIf="isWordPurchased">
        <div class="row pdf-purchased" (click)="onDownloadWord()">
          <p class="col m-0 d-flex align-items-center justify-content-center">
            <img src="./assets/icon/word.png" />
            <span>{{ "Download LinkedIn Profile" | translate }}</span>
          </p>
          <p class="col-auto">
            <i class="pi pi-download"></i>
          </p>
        </div>
        <div class="purchase-status mt-2">
          <i class="pi pi-check-circle"></i>
          <span>{{ "Profile Purchased" | translate }}</span>
        </div>
      </div>

      <div class="mt-3">
        <button class="cl-border-button w-100" (click)="createNewLinkedinProfile()">
          {{ "Create New Profile" | translate }}
        </button>
      </div>
    </div>

    <div class="col-12 col-md-7 col-lg-8 order-1 order-md-2 cv-preview-container"
      (contextmenu)="$event.preventDefault()">
      <div class="text-center position-relative">

        <img [src]="linkedinUrlImage" alt="Generated LinkedIn Profile Preview"
          [style.filter]="!isWordPurchased ? 'blur(6px)' : 'none'"
          [style.pointer-events]="!isWordPurchased ? 'none' : 'auto'" />

        <div *ngIf="!isWordPurchased" class="blur-overlay">
          <div class="blur-overlay-content">
            <i class="pi pi-lock" style="font-size: 2rem; color: white;"></i>
            <p style="color: white; font-weight: bold; margin-top: 8px;">
              {{ "Purchase to unlock your profile" | translate }}
            </p>
      
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
</div>

<!-- Services Section -->
<section class="services-section">
  <div class="container">
    <div class="row justify-content-center p-0">
      <!-- Title Card -->
      <div class="col-12 col-sm-6 col-md-4">
        <div class="title-card">
          <h3 class="services-main-title">
            {{ "Resume optimization checklist" | translate }}
          </h3>
          <p class="services-main-description">
            {{ "resume_checks_description" | translate }}
          </p>
        </div>
      </div>

      <!-- Service Cards -->
      <app-card *ngFor="let item of services" [color]="item.color" [img]="item.img" [icon]="true" [title]="item.title"
        [description]="item.description" />
    </div>
  </div>
</section>

<section class="cv-section">
  <div class="container">
    <div class="text-center">
      <h3 class="titlle">{{ 'linkedInScan.title' | translate }}</h3>
    </div>
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-12 col-md-5 mb-4 mb-md-0 text-center">
        <img class="img-fluid" src="assets/img/Frame_2095587930-removebg-preview.png" alt="LinkedIn Scan Image" />
      </div>

      <div class="col-12 col-md-7 px-md-5">
        <ul class="linkedin-scan-list">
          <li>
            <span class="check-icon"><i class="pi pi-check"></i></span>
            {{ 'linkedInScan.point1' | translate }}
          </li>
          <li>
            <span class="check-icon"><i class="pi pi-check"></i></span>
            {{ 'linkedInScan.point2' | translate }}
          </li>
          <li>
            <span class="check-icon"><i class="pi pi-check"></i></span>
            {{ 'linkedInScan.point3' | translate }}
          </li>
        </ul>
        <button class="gradient-button" routerLink="/scan-linkedin">
          {{ 'Scan Your Profile' | translate }}
        </button>
      </div>
    </div>
  </div>
</section>